import { render, staticRenderFns } from "./providers-v2.tab.vue?vue&type=template&id=63c88bb0&scoped=true"
import script from "./providers-v2.tab.vue?vue&type=script&lang=js"
export * from "./providers-v2.tab.vue?vue&type=script&lang=js"
import style0 from "./providers-v2.tab.vue?vue&type=style&index=0&id=63c88bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c88bb0",
  null
  
)

export default component.exports